module.exports = __webpack_public_path__ + "static/media/Rubik-Light.2c4521f8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Light/Rubik-Light.woff
// module id = 1298
// module chunks = 49